import { FC, useState } from "react";
import {
  INBOX_SECTIONS,
  formatBadgeCount,
  useGetUnreadCountQuery,
} from "entities/notification";
import type { NotificationItem, NotificationType } from "entities/notification";
import { MarkAllReadButton } from "features/read-notifications";
import { Tabs } from "shared/ui";
import { InboxList } from "./InboxList";

import styles from "./InboxDropdown.module.css";

interface Props {
  onItemClick: (item: NotificationItem) => void;
}

export const InboxDropdown: FC<Props> = ({ onItemClick }) => {
  const [activeType, setActiveType] = useState<NotificationType>("news");
  // Счётчики секций — только из unread-count, не из categories.count.
  const { data: unread } = useGetUnreadCountQuery();

  return (
    <div className={styles.dropdown}>
      <div className={styles.header}>
        <span className={styles.heading}>Notifications</span>
        <MarkAllReadButton disabled={!unread?.total} />
      </div>

      <Tabs
        items={INBOX_SECTIONS.map(({ type, title }) => {
          const count = unread?.by_type[type] ?? 0;
          return {
            value: type,
            label: title,
            badge: count > 0 ? formatBadgeCount(count) : undefined,
          };
        })}
        active={activeType}
        onChange={setActiveType}
      />

      <InboxList key={activeType} type={activeType} onItemClick={onItemClick} />
    </div>
  );
};
